import { ChangeDetectionStrategy, Component, Inject, NgModule } from "@angular/core";
import { MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
//import {MatDialog, MAT_DIALOG_DATA} from '@angular/material';

export interface DialogData {
  message: '';
}

/**
 * @title Injecting data when opening a dialog
 */
@Component({
  selector: "app-alert-dialog",
  templateUrl: "./alert-dialog.component.html",
  styleUrls: ["./alert-dialog.component.scss"],
  standalone: true,
  imports: [
    TranslateModule
  ],

})
export class AlertDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData,public dialog : MatDialog) {

  }

  closeDialog(){
    this.dialog.closeAll();
  }

}
